module.exports = __webpack_public_path__ + "static/media/ic_ticket.6c593940.svg";